import { createDraft, Draft, finishDraft, Immutable } from 'immer'
import { isImmerDraft } from 'embed/utils/immer/is-immer-draft'
import { VariantName } from './common'

export type Experiment = Immutable<{
  enabled: boolean
  hasError: boolean
  started: boolean
  variantName: VariantName | undefined
}>
export function createExperiment(propertiesToSet?: Partial<Experiment> | undefined): Experiment {
  const experiment = {
    enabled: false,
    hasError: false,
    started: false,
    variantName: undefined,
  }

  return propertiesToSet ? Object.assign(experiment, propertiesToSet) : experiment
}
export function updateExperiment(experiment: undefined, propertiesToSet?: undefined): undefined
export function updateExperiment(experiment: undefined, propertiesToSet: Partial<Experiment>): Experiment
export function updateExperiment(experiment: Experiment, propertiesToSet?: Partial<Experiment> | undefined): Experiment
export function updateExperiment(
  experiment: Draft<Experiment>,
  propertiesToSet?: Partial<Experiment> | undefined,
): Draft<Experiment>
export function updateExperiment(
  experiment: Draft<Experiment> | Experiment | undefined,
  propertiesToSet?: Partial<Experiment> | undefined,
): Draft<Experiment> | Experiment | undefined {
  if (experiment === undefined) {
    return propertiesToSet === undefined ? undefined : createExperiment(propertiesToSet)
  }
  if (propertiesToSet === undefined) {
    return experiment
  }
  const experimentIsAlreadyDraft = isImmerDraft(experiment)
  const draftExperiment: Draft<Experiment> = experimentIsAlreadyDraft ? experiment : createDraft(experiment)
  Object.assign(draftExperiment, propertiesToSet)
  return experimentIsAlreadyDraft ? draftExperiment : finishDraft(draftExperiment)
}
